<template>
  <div class="page-container">
    <div class="query-title">要货单批量审批</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <!-- <template #button>
            <table-button name="export" tip="审批通过" @click="approve(1)" />
            <table-button name="export" tip="审批退回" @click="approve(2)" />
          </template> -->
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="left"
            size="mini"
            show-overflow
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          >
            <template #wantCode="{ row }">
              <el-link type="primary" @click="toDetail(row)">{{ row.wantCode }}</el-link>
            </template>
            <!-- <template #baseAuditQuantity="{ row }">
              <el-input v-model="row.baseAuditQuantity" size="mini" :disabled="row.subProcUnitId !== 'base'" />
            </template>
            <template #warAuditQuantity="{ row }">
              <el-input v-model="row.warAuditQuantity" size="mini" :disabled="row.subProcUnitId !== 'warZone'" />
            </template>
            <template #salecenterAuditQuantity="{ row }">
              <el-input v-model="row.salecenterAuditQuantity" size="mini" :disabled="row.subProcUnitId !== 'work'" />
            </template>
            <template #handleOpinion="{ row }">
              <el-input v-model="row.handleOpinion" size="mini" />
            </template> -->
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import tableMixins from '@/utils/tableMixins'
import pageConfig, { pageSearch } from './config/toGoodsBatchApprove'
import { apiWantGoodsApproveList, apiWantGoodsApprove } from '@/api/common'
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      pageSearch,
      gridOptions: {
        columns: [
          // { type: 'checkbox', field: 'checkbox', title: '', width: 40 }
        ],
        data: []
      },
      searchField: {},
      isSetFilter: false
    }
  },
  computed: {
    ...mapGetters(['role'])
  },
  created() {
    this.initPage(pageConfig)
  },
  methods: {
    cellClassName({ column }) {
      return column.params?.bgEdit ? 'cell--bg--edit' : 'cell--bg--default'
    },
    toDetail(row) {
      this.$router.push({
        path: '/wly/to-goods/business-processing/deliver-approve',
        query: {
          id: row.id,
          taskId: row.taskId
        }
      })
    },
    async approve(type) {
      const checkdata = this.$refs.xTable.getCheckboxRecords()
      if (!checkdata.length) return this.$message.warning('请选择有效数据！')
      let data = []
      try {
        data = checkdata.map(item => {
          if (item.subProcUnitId === 'base') {
            if (!item.baseAuditQuantity) {
              throw new Error(`请填写单号为：${item.billCode}的审批数量！`)
            }
          } else if (item.subProcUnitId === 'warZone') {
            if (!item.warAuditQuantity) {
              throw new Error(`请填写单号为：${item.billCode}的审批数量！`)
            }
          } else if (item.subProcUnitId === 'work') {
            if (!item.salecenterAuditQuantity) {
              throw new Error(`请填写单号为：${item.billCode}的审批数量！`)
            }
          }
          return {
            warAuditQuantity: item.warAuditQuantity,
            salecenterAuditQuantity: item.salecenterAuditQuantity,
            baseAuditQuantity: item.baseAuditQuantity,
            taskId: item.taskId,
            handleOpinion: item.handleOpinion,
            handleResult: type
          }
        })
      } catch (e) {
        this.$message.warning(e.message)
        return
      }

      const res = await apiWantGoodsApprove(data)
      if (res.status === 1) {
        this.queryData()
        return this.$message.success('操作成功！')
      }
      return this.$message.error(res.msg)
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
      }
      const params = {
        // user_bp: this.$store.getters.role.USER_BP,
        // role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data: { Rows, Total }, calculation, field } = await apiWantGoodsApproveList(params)
        if (Rows.length === 0 && Total) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = Total - 0
        this.calculation = this.filtercalculation(calculation, 'xTable', true)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(Rows)
        } else {
          this.gridOptions.data = Rows.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field, 'xTable', true)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    handleTablePaginationChange(page) {
      Object.assign(this.pagination, page)
      this.queryData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/toGoodsBatchApprove.vue